type WhatsAppField = {
  label: string;
  value?: string | number | null;
};

type WhatsAppLeadPayload = {
  title: string;
  fields: WhatsAppField[];
  number?: string;
};

const DEFAULT_WHATSAPP_NUMBER = '79381512222';

const normalizePhoneNumber = (value: string) => value.replace(/\D/g, '');

const normalizeFieldValue = (value?: string | number | null) => {
  if (value === null || value === undefined) return '';
  return String(value).trim();
};

export const sendLeadToWhatsApp = ({ title, fields, number }: WhatsAppLeadPayload): boolean => {
  if (typeof window === 'undefined') return false;

  const targetNumber = normalizePhoneNumber(number || process.env.REACT_APP_WHATSAPP_NUMBER || DEFAULT_WHATSAPP_NUMBER);
  if (!targetNumber) return false;

  const lines: string[] = [`Новая заявка: ${title}`];

  fields.forEach((field) => {
    const value = normalizeFieldValue(field.value);
    if (!value) return;
    lines.push(`${field.label}: ${value}`);
  });

  lines.push(`Время: ${new Date().toLocaleString('ru-RU')}`);

  const url = `https://wa.me/${targetNumber}?text=${encodeURIComponent(lines.join('\n'))}`;
  window.location.assign(url);

  return true;
};
